import { Component, Input } from "@angular/core";

@Component({
    selector: "app-label-data",
    templateUrl: "./label-data.component.html",
    styleUrls: ["./label-data.component.scss"]
})
export class LabelDataComponent {
    @Input() label: string;
    @Input() data: string;
}


// WEBPACK FOOTER //
// ./src/app/verify/shared/component/label-data/label-data.component.ts